
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class FloatingShapesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const size = (2 + (config.parallaxLayers - layerIndex) * 2) * (config.parallaxScale || 1.0);

        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const shapes = ['TRIANGLE', 'SQUARE', 'PENTAGON', 'HEXAGON', 'STAR_5'];

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 2 * (config.parallaxScale || 1.0);

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const offX = this.pseudoRandom(x + layerIndex) * spacing;
                const offY = this.pseudoRandom(y + layerIndex) * spacing;
                const s = size * 5 * (0.5 + this.pseudoRandom(x + y) * 1.5);
                const shape = shapes[Math.floor(this.pseudoRandom(x + y + layerIndex) * shapes.length)];
                const rot = this.pseudoRandom(x - y) * Math.PI * 2;
                
                const draw = () => {
                    ctx.save();
                    ctx.translate(x + offX, y + offY);
                    ctx.rotate(rot);
                    ctx.beginPath();
                    const sides = shape === 'TRIANGLE' ? 3 : shape === 'SQUARE' ? 4 : shape === 'PENTAGON' ? 5 : 6;
                    for (let i = 0; i < sides; i++) {
                        const a = (i / sides) * Math.PI * 2;
                        const px = Math.cos(a) * s;
                        const py = Math.sin(a) * s;
                        if (i === 0) ctx.moveTo(px, py);
                        else ctx.lineTo(px, py);
                    }
                    ctx.closePath();
                    ctx.stroke();
                    ctx.restore();
                };

                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
